<template>
<div class="header-bg">
  <div id="header">
    <div class="top-header">
      <ul class="zyz-t1">
    <!--     <li>
          <div class="dt">
            <a href='/shop/apply/' class="ahover">
                <img src="~@/assets/images/组 28.png" class="zyz-tb">
            关注店铺</a>
          </div>
        </li>
        <li>
          <div class="dt">
            <a href='/shop/apply/' class="ahover">
              <img src="~@/assets/images/组 28 (1).png" class="zyz-tb">
            联系客服</a>
          </div>
        </li>
        <li>
          <div class="dt">
            <a href='/shop/apply/' class="ahover">
            <img src="~@/assets/images/pinpai.png" class="zyz-tb">
            品牌会员</a>
          </div>
        </li>-->
      </ul>

      <en-logo/>
      <en-search/>
      <en-settleup/>
    </div>
    <en-nav/>
  </div>
</div>

</template>

<script>
  export default {
    name: 'EnHeader'
  }
</script>

<style type="text/scss" lang="scss" scoped>
  @import "../assets/styles/color";
  .header-bg{
    background:#fff;
    padding-bottom:20px
  }
  #header {
    // border-bottom: 1px solid $color-main;
    margin: auto;
    width: 1210px;
    .top-header {
      display: flex;
      justify-content: space-between;
      height: 67px;
      // padding-top: 30px;
      padding-top: 20px;
      /deep/ #logo {
        // width: 240px;
        // height: 60px;
            width: 158px;
height: 58px;
      }
      .zyz-t1{
        z-index: 100;
        position: absolute;
        height: 30px;
        margin: 19px auto;
        top: 50px;
        right: 260px;
        height: 14px;
        font-size: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
        font-weight:bolder;
        text-align: left;
        color: #000000;
        line-height: 18px;
        li {
          position: relative;
          float: left;
          padding: 0 10px;
          .zyz-tb{
                width: 17px;
    height: 17px;
    position: relative;
    top: -2px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue